import script from "./FilaAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./FilaAlumno.vue?vue&type=script&setup=true&lang=js"

import "./FilaAlumno.vue?vue&type=style&index=0&id=79f4242d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f4242d"]])

export default __exports__